<template>
  <div class="p-4">
    <div class="row">
      <div class="col-6">
        <div><strong>Inbound #: </strong>{{ order.number }}</div>
        <div><strong>Status: </strong>{{ order.status.name }}</div>
        <div><strong>Client: </strong>{{ order.client.name }}</div>
        <div><strong>Created: </strong>{{ createdAt }}</div>
        <div><strong>PO Number: </strong>{{ order.po_number }}</div>
        <strong>Ship To:</strong><br />
        <address>
          {{ order.destination.name }}<br />
          {{ order.destination.address }}<br />
          {{ order.destination.city }} {{ order.destination.state }} {{ order.destination.zip }}
        </address>
    
      </div>
      <div class="col-6">
        <div v-if="order.transport_id"><strong>Transport: </strong>
          <router-link :to="`/transport/${order.transport_id}`">
            TR-{{ order.transport_id }}
          </router-link> / 
          <a :href="bolUrl(order.transport_id)" target="_blank">Print BOL</a>
        </div>
        <div v-else>
          <button class="btn btn-dark" @click="createTransport(order.id)">Create L&amp;M Transport</button>
        </div>
        <div v-if="order.invoice_id">
          <strong>Invoice: </strong> {{ order.invoice_id }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'

export default {
  name: 'order-meta',

  props: {
    order: Object
  },

  components: {

  },

  computed: {
    eta() {
      return this.order.eta ? moment(this.order.eta).format("l") : 'N/A'
    },

    createdAt() {
      return moment(this.order.created_at).format("l")
    }
  },

  methods: {
    createTransport(id) {
      api.post(`/outbound-orders/${id}/transport`).then(res => {
        const order = res.data.order
        this.$router.push(`/transport/${order.transport_id}`)
      })
    },

    bolUrl(id) {
      return `${api.baseUrl}/transport/${id}/bol`
    },

    calendar(date) {
      return date ? moment(date).calendar() : 'N/A'
    }
  }

}
</script>
